import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { Mail, MessageSquare, Send } from 'lucide-react';
import { Breadcrumbs } from '../components/Breadcrumbs';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In production, this would send to your backend
    const mailtoLink = `mailto:support@shopilots.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(`From: ${formData.name} (${formData.email})\n\n${formData.message}`)}`;
    window.location.href = mailtoLink;
    setSubmitted(true);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="min-h-screen bg-slate-50" data-id="element-742">
      {/* Header */}
      <header className="sticky top-0 z-10 backdrop-blur supports-[backdrop-filter]:bg-white/70 bg-white/90 border-b border-slate-200" data-id="element-743">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-4" data-id="element-744">
          <div className="flex items-center justify-between" data-id="element-745">
            <div className="flex items-center gap-4" data-id="element-746">
              <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-id="element-747">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4yJ3FscyPfrN1xAm7crLNW/ChatGPT_Image_Dec_2%2C_2025%2C_10_42_07_PM.png" alt="Shopping Expert.ai Logo" className="h-12 object-contain" data-id="element-748" />
                <span className="text-xl font-bold text-slate-900" data-id="element-749">
                  AI Shopping Expert
                </span>
              </Link>
            </div>
            <nav className="hidden md:flex items-center gap-6 text-sm" data-id="element-750">
              <Link to="/" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-751">
                Home
              </Link>
              <Link to="/research" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-752">
                Research Tools
              </Link>
              <Link to="/about" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-753">
                About
              </Link>
              <Link to="/contact" className="text-slate-900 font-semibold border-b-2 border-slate-900 pb-1" data-id="element-754">
                Contact
              </Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="mx-auto max-w-4xl px-4 sm:px-6 py-12" data-id="element-755">
        <Breadcrumbs items={[{
        label: 'Contact',
        href: '/contact'
      }]} data-id="element-756" />

        <div className="grid md:grid-cols-2 gap-8" data-id="element-757">
          {/* Contact Info */}
          <div data-id="element-758">
            <h1 className="text-4xl font-bold text-slate-900 mb-6" data-id="element-759">
              Get in Touch
            </h1>
            <p className="text-lg text-slate-700 leading-relaxed mb-8" data-id="element-760">
              Have questions, suggestions, or want to submit a tool? We'd love
              to hear from you.
            </p>

            <div className="space-y-6" data-id="element-761">
              <div className="flex gap-4" data-id="element-762">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-blue-100 grid place-items-center" data-id="element-763">
                  <Mail size={24} className="text-blue-600" data-id="element-764" />
                </div>
                <div data-id="element-765">
                  <h3 className="font-bold text-slate-900 mb-1" data-id="element-766">Email Us</h3>
                  <a href="mailto:support@shopilots.com" className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-767">
                    support@shopilots.com
                  </a>
                  <p className="text-sm text-slate-600 mt-1" data-id="element-768">
                    We typically respond within 24 hours
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-769">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-purple-100 grid place-items-center" data-id="element-770">
                  <MessageSquare size={24} className="text-purple-600" data-id="element-771" />
                </div>
                <div data-id="element-772">
                  <h3 className="font-bold text-slate-900 mb-1" data-id="element-773">
                    Submit a Tool
                  </h3>
                  <p className="text-sm text-slate-700" data-id="element-774">
                    Know an AI shopping tool we should add? Send us the details
                    and we'll review it within 48 hours.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8" data-id="element-775">
            {submitted ? <div className="text-center py-8" data-id="element-776">
                <div className="w-16 h-16 rounded-full bg-green-100 grid place-items-center mx-auto mb-4" data-id="element-777">
                  <Send size={32} className="text-green-600" data-id="element-778" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-779">
                  Message Sent!
                </h3>
                <p className="text-slate-600" data-id="element-780">
                  We'll get back to you as soon as possible.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-781">
                <div data-id="element-782">
                  <label htmlFor="name" className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-783">
                    Name
                  </label>
                  <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-slate-900 focus:border-transparent outline-none transition-all" placeholder="Your name" data-id="element-784" />
                </div>

                <div data-id="element-785">
                  <label htmlFor="email" className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-786">
                    Email
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-slate-900 focus:border-transparent outline-none transition-all" placeholder="your@email.com" data-id="element-787" />
                </div>

                <div data-id="element-788">
                  <label htmlFor="subject" className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-789">
                    Subject
                  </label>
                  <select id="subject" name="subject" required value={formData.subject} onChange={handleChange} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-slate-900 focus:border-transparent outline-none transition-all" data-id="element-790">
                    <option value="" data-id="element-791">Select a subject</option>
                    <option value="Submit a Tool" data-id="element-792">Submit a Tool</option>
                    <option value="Report an Error" data-id="element-793">Report an Error</option>
                    <option value="Partnership Inquiry" data-id="element-794">
                      Partnership Inquiry
                    </option>
                    <option value="General Question" data-id="element-795">General Question</option>
                    <option value="Other" data-id="element-796">Other</option>
                  </select>
                </div>

                <div data-id="element-797">
                  <label htmlFor="message" className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-798">
                    Message
                  </label>
                  <textarea id="message" name="message" required rows={5} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-slate-900 focus:border-transparent outline-none transition-all resize-none" placeholder="Tell us more..." data-id="element-799" />
                </div>

                <button type="submit" className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 bg-slate-900 text-white rounded-xl font-semibold hover:bg-black transition-colors" data-id="element-800">
                  <Send size={18} data-id="element-801" />
                  Send Message
                </button>
              </form>}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white mt-16" data-id="element-802">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-8" data-id="element-803">
          <p className="text-sm text-slate-500 text-center" data-id="element-804">
            © 2025 ShoppingExpert.ai. All rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}